import React from 'react';
import { EyeOff } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';

const SupervisionBanner: React.FC = () => {
    const [searchParams] = useSearchParams();
    const isImpersonating = searchParams.get('impersonate') === 'true';

    const exitImpersonation = () => {
        window.close(); // Pestaña abierta por _blank, se debe cerrar
    };

    return (
        <AnimatePresence>
            {isImpersonating && (
                <motion.div
                    initial={{ y: -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -50, opacity: 0 }}
                    className="fixed top-0 left-0 right-0 z-[9999] flex justify-center pointer-events-none p-2"
                >
                    <div className="bg-emerald-500/90 backdrop-blur-md text-white px-4 py-2 rounded-full shadow-lg border border-emerald-400/50 flex items-center gap-3 pointer-events-auto">
                        <div className="flex items-center gap-2">
                            <span className="relative flex h-3 w-3">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-100"></span>
                            </span>
                            <span className="text-xs font-black uppercase tracking-widest whitespace-nowrap">
                                Viendo como Super Admin
                            </span>
                        </div>
                        <button
                            onClick={exitImpersonation}
                            className="ml-2 bg-white/20 hover:bg-white/30 transition-colors px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1 active:scale-95"
                        >
                            <EyeOff className="w-3 h-3" />
                            Cerrar Pestaña
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default SupervisionBanner;
